import { TFunction } from 'i18next';
import { ApiJobDetailOk } from '@type/v1-api-types';

export const getJobMetaDescription = (job: ApiJobDetailOk | null, t: TFunction) => {
  if (!job) {
    return t('meta.homepage.description_react');
  }

  const metaDescriptionKey = job.remote ? 'job.detail.meta.description.remote.react' : 'job.detail.meta.description.react';
  const locationParts = [];
  if (job.locations?.length) {
    locationParts.push(job.locations.map((location) => location.name).join(', '));
  }
  if (job.partialRemote) {
    locationParts.push(t('meta.label.partial.remote'));
  }

  return t(metaDescriptionKey, {
    employer: job.employer?.employerName,
    jobTitle: job.title,
    location: locationParts.join(', '),
  });
};
